import { Component, Input, SimpleChanges } from '@angular/core';
import { ProponenteService } from 'administrativo-lib';
import {
  BaseResourceItemsComponent,
  Contrato,
  ContratoRemanejo,
  ContratoRemanejoItem,
  DateFormatPipe,
  FuncaoService,
  GlobalService
} from 'eddydata-lib';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { ContratoRemanejoService } from '../service/contrato-remanejo.service';

declare var $: any;

@Component({
  selector: 'lib-contrato-remanejo',
  templateUrl: './contrato-remanejo.component.html'
})
export class ContratoRemanejoComponent extends BaseResourceItemsComponent<ContratoRemanejo> {

  public ptBR: any;
  public itemAtual: ContratoRemanejo;
  public visualizar_item: boolean;
  public listaRemanejo: ContratoRemanejo[] = [];
  public inabilitarBotao = false;

  @Input() public contrato: Contrato;
  @Input() visualizarC: Boolean = false;


  imaskConfig = {
    mask: Number,
    scale: 2,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    protected globalService: GlobalService,
    public funcaoService: FuncaoService,
    public proponenteService: ProponenteService,
    public remanejoService: ContratoRemanejoService) {
    super(new ContratoRemanejo(), remanejoService);
  }

  protected afterInit(): void {
    this.ptBR = this.globalService.obterDataBR();
  }

  protected validSave(item: ContratoRemanejo): boolean {
    if (!item.data_contabilizacao) {
      toastr.warning(`Informe a data de contabilização do remanejo de ${item.proponente?.favorecido?.nome || 'identificador desconhecido'}!`);
      return false;
    }
    if (!item.data_remanejo) {
      toastr.warning(`Informe a data do remanejo de ${item.proponente?.favorecido?.nome || 'identificador desconhecido'}!`);
      return false;
    }
    if (!item.especie) {
      toastr.warning(`Informe a espécie do remanejo de ${item.proponente?.favorecido?.nome || 'identificador desconhecido'}!`);
      return false;
    }
    if (!item.motivo) {
      toastr.warning(`Informe o motivo do remanejo de ${item.proponente?.favorecido?.nome || 'identificador desconhecido'}!`);
      return false;
    }
    if (!this.funcaoService.podeAlterarAudesp(item.data_contabilizacao, this.login)) {
      toastr.warning(`Não é possível alterar o remanejo de ${item.proponente?.favorecido?.nome || 'identificador desconhecido'}. Prazo esgotado!`);
      return false;
    }
    return true;
  }

  protected beforeSave(item: ContratoRemanejo): void { }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public async adicionar() {
    this.visualizar_item = false;
    this.itemAtual = null;
    this.listaRemanejo = [];
    this.proponenteService.obterPorLicitacao(this.contrato.licitacao.id, false).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        if (res.content?.length) {
          for (const prop of res.content) {
            let remanejoNovo = new ContratoRemanejo();
            remanejoNovo.data_remanejo = this.funcaoService.obterDataUTC(new Date());
            remanejoNovo.data_contabilizacao = this.funcaoService.obterDataUTC(new Date());
            remanejoNovo.contrato = this.contrato;
            remanejoNovo.usuario = this.login.usuario;
            remanejoNovo.exercicio = this.login.exercicio;
            remanejoNovo.proponente = prop
            remanejoNovo.editavel = true;
            remanejoNovo.especie = 'E';
            remanejoNovo.valor_total = 0;
            remanejoNovo.itens = [];
            for (const item of this.contrato.itens) {
              remanejoNovo.itens.push({ quantidade: 0, saldo: item['saldo_qtd'], valor_unitario: item['vl_unit_atualizado'], contrato_item: item });
            }

            this.listaRemanejo.push(remanejoNovo)
          }
          this.listaRemanejo = [...this.listaRemanejo]
          this.listaRemanejo.sort((a, b) => a.proponente.favorecido.nome.localeCompare(b.proponente.favorecido.nome));
        }
        $('#dialogRemanejo').modal('show');
      })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.lista) {
      this.lista = this.lista.sort((a, b) => { return +new Date(a.data_remanejo) - +new Date(b.data_remanejo) });
    }
  }

  public verificarSaldoBotao() {
    if (this.contrato.id) {
      const valorTotal = this.contrato.itens.reduce((soma, item) => {
        return soma + (item['saldo_qtd'] * item.vl_unit_atualizado);
      }, 0);

      return valorTotal <= 0;
    }
  }

  public ordernarLista(event) {
    this.remanejoService.filtrar(1, -1, {
      'contrato.id': this.contrato.id,
      relations: 'usuario,itens.contrato_item.produto_unidade.produto,proponente.favorecido',
      orderBy: 'data_remanejo$DESC'
    })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.lista = res.content;
      });
  }

  public editar(item: ContratoRemanejo) {
    this.visualizar_item = false;
    this.itemAtual = item;
    // this.entity.editavel = true;
    this.itemAtual.data_remanejo = new DateFormatPipe().transform(item.data_remanejo, []);
    this.itemAtual.data_contabilizacao = new DateFormatPipe().transform(item.data_contabilizacao, []);
    this.itemAtual.itens.map(itm => itm.contrato_item['cota'] = this.retornaCota(itm, item.itens) === 'P' ? 'PRINCIPAL' : 'RESERVADO')
    $('#dialogRemanejo').modal('show');
  }

  public visualizar(item: ContratoRemanejo) {
    this.itemAtual = { ...item };
    this.itemAtual.data_remanejo = new DateFormatPipe().transform(item.data_remanejo, []);
    this.itemAtual.data_contabilizacao = new DateFormatPipe().transform(item.data_contabilizacao, []);
    this.visualizar_item = true;
    $('#dialogRemanejo').modal('show');
  }

  public condicaoEdicao(item: ContratoRemanejo): Boolean {
    // const hoje = Date.now()
    // return this.funcaoService.converteDataSQL(new Date(hoje)) <= this.funcaoService.converteDataSQL(new Date(item.data_contabilizacao))

    const diasBloqueio = this.login.parametro.contabil?.dias_bloquear_alteracoes
    const dataAudesp = this.login.ultimoAudesp
    const dataContabilizacao = this.funcaoService.zerarHoras(new Date(item.data_contabilizacao))


    const dataLimiteSuperior = this.funcaoService.adicionarDia(diasBloqueio, this.funcaoService.zerarHoras(new Date()))
    const dataLimiteInferior = this.funcaoService.adicionarDia(diasBloqueio, this.funcaoService.zerarHoras(new Date()), false, true)

    if (dataContabilizacao >= dataLimiteSuperior || dataContabilizacao <= dataLimiteInferior) {
      return false
    } else {
      const mes = +dataAudesp.split('-')[1]
      const ano = +dataAudesp.split('-')[0]

      if ((dataContabilizacao.getFullYear() < ano || (dataContabilizacao.getFullYear() === ano && (+dataContabilizacao.getMonth() + 1) <= mes)) && mes < 12) {
        return false
      } else {
        return true
      }
    }
  }

  public retornaCota(itemAtual: ContratoRemanejoItem, lista: ContratoRemanejoItem[]) {
    let cota: 'P' | 'R'
    if (itemAtual.contrato_item.memorial) {
      cota = itemAtual.contrato_item.memorial.cota === 'PRINCIPAL' ? 'P' : itemAtual.contrato_item.memorial.cota === 'NAO_DEFINIDO' ? 'P' : 'R'
    } else {
      let itemIgual = lista.find(it => it.contrato_item.produto_unidade.id === itemAtual.contrato_item.produto_unidade.id && it.id !== itemAtual.contrato_item.id)
      cota = !itemIgual ? 'P' : +itemAtual.contrato_item.quantidade > +itemIgual.contrato_item.quantidade ? 'P' : 'R'
    }
    return cota
  }

  public podeVisualizar() {
    if (this.visualizarC === true) {
      return true;
    }
    if (this.visualizarC === false) {
      return false;
    }
  }
}